"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = UtilWebVitals;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _webVitals = require("web-vitals");
var _core = require("@emotion/core");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var isBrowser = typeof window !== "undefined";
function UtilWebVitals(_ref) {
  var path = _ref.path,
    children = _ref.children;
  (0, _react.useEffect)(function () {
    (0, _webVitals.getCLS)(sendToGTM);
    (0, _webVitals.getFID)(sendToGTM);
    (0, _webVitals.getLCP)(sendToGTM);
    (0, _webVitals.getTTFB)(sendToGTM);
    (0, _webVitals.getFCP)(sendToGTM);
  }, [path]);
  var sendToGTM = (0, _react.useCallback)(function (_ref2) {
    var name = _ref2.name,
      delta = _ref2.delta,
      id = _ref2.id;
    if (isBrowser) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "web-vitals",
        event_category: "Web Vitals",
        event_action: name,
        // Google Analytics metrics must be integers, so the value is rounded.
        // For CLS the value is first multiplied by 1000 for greater precision
        // (note: increase the multiplier for greater precision if needed).
        event_value: Math.round(name === "CLS" ? delta * 1000 : delta),
        // The `id` value will be unique to the current page load. When sending
        // multiple values from the same page (e.g. for CLS), Google Analytics can
        // compute a total by grouping on this ID (note: requires `eventLabel` to
        // be a dimension in your report).
        event_label: id
      });
    }
  }, []);
  return (0, _core.jsx)(_react["default"].Fragment, null, children);
}
UtilWebVitals.propTypes = {
  path: _propTypes["default"].string,
  /** children of this component, this should ideally be a top level component, for future compatibility*/
  children: _propTypes["default"].node
};